type ToggleIndexAction = {
  type: "toggle_index";
  payload: number;
};
type OpenIndexAction = {
  type: "open_index";
  payload: number;
};
export type OfferingFormAccordionActions = ToggleIndexAction | OpenIndexAction;

export type OfferingFormAccordionState = {
  openIndexes: number[];
};

export const initialOfferingFormAccordionState: OfferingFormAccordionState = {
  openIndexes: [0],
};

export const offeringFormAccordionReducer = (
  state: OfferingFormAccordionState = initialOfferingFormAccordionState,
  action: OfferingFormAccordionActions
) => {
  if (action.type === "toggle_index") {
    const closing = state.openIndexes.includes(action.payload);
    return closing
      ? {openIndexes: state.openIndexes.filter((i) => i !== action.payload)}
      : {...state, openIndexes: [...state.openIndexes, action.payload]};
  }
  if (action.type === "open_index") {
    // Returns the same state when already open so callers can dispatch this from an
    // effect without looping.
    return state.openIndexes.includes(action.payload)
      ? state
      : {...state, openIndexes: [...state.openIndexes, action.payload]};
  }
  return state;
};
